<template>
    <div>
        <b-container>
            <b-row>
                <b-col>
                    <app-ticket-filter-finalized
                        @filter="onFilter"
                    ></app-ticket-filter-Finalized>
                </b-col>
            </b-row>
            <b-row>
            <b-col>
                <app-ticket-list-finalized
                    :table-data="tableData"
                    :on-change-page="onChangePage"
                    @sort ="onSort"
                    @edit="onEdit"
                ></app-ticket-list-finalized>
            </b-col>
        </b-row>
        <app-pop-up
                id="ticketFinalized-form-window"
                title="Informacion de ticket de soporte"
                size="large"
            >
                <template slot="body">
                    <app-ticket-form-finalized
                        ref="ticketFormFinalized"
                    ></app-ticket-form-finalized>
                </template>
            </app-pop-up>
        </b-container>
    </div>
</template>
<script>
import ticketFilterFinalized from './TicketFilterFinalized';
import ticketListFinalized from './TicketListFinalized';
import ticketFormFinalized from './TicketFormFinalized'
export default {
    data: () => ({
        page: 1,
        filters: null,
        tableData: '',
        sortBy: 'tickets.created_at',
        sortDir: 'desc',
        attended: true,
        requestedInfo: true,
        finalize: true,
        closeReq: true,
        flagPageTicketFinalized: true

    }),
    components: {
        appTicketFilterFinalized: ticketFilterFinalized,
        appTicketListFinalized: ticketListFinalized,
        appTicketFormFinalized: ticketFormFinalized
    },
    methods: {
        onFilter(filters) {
            if(filters.statusId =='' && filters.from == '' && filters.to == '' && filters.moduleId == ''
                && filters.ticketNumber == '' && filters.description == '' && filters.title ==''){
                this.flagPageTicketFinalized = true;
                this.loadTickets();
            }else{
            this.filters = filters;         
            this.page = 1;
            this.flagPageTicketFinalized = '';
            this.loadTickets();
            }
            
        },
        async loadTickets() {
            try {
                const params = {...this.filters, page: this.page, sortBy: this.sortBy, 
                sortDir: this.sortDir,flagPageTicketFinalized: this.flagPageTicketFinalized};
                const {data} = await repo.get('tickets',params);
                this.tableData = data;
            } catch(err) {
                this.handleErrors(err);
            }
        },
        onChangePage(page) {
            this.page = page;
            this.loadTickets();
        },
        onSort(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDir = ctx.sortDir;
            this.loadTickets();
        },
        onEdit(ticket) {
            this.$refs.ticketFormFinalized.fill(ticket);
            this.$bus.$emit("ticketFinalized-form-window.open");
        },
        
    },
    mounted() {
        this.loadTickets();
        this.$bus.$on('ticket-finalized.load', this.loadTickets);
        this.$bus.$on('ticket-closed.load', this.loadTickets);
    }

}
</script>
